<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>历史库存</el-breadcrumb-item>
      </el-breadcrumb>
      <operation-help namespace="stock" help-key="bound-day" />
    </template>
    <el-form label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="query.keyword" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属公司">
          <el-col>
            <el-tree-select ref="companys" v-model="companyId" :data="companys" @change="companyChange();"
              check-strictly :render-after-expand="false" style="min-width: 210px;" />
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="所属部门">
          <el-col>
            <el-tree-select ref="channels" v-model="channel" :data="channels" @change="fetchs();" clearable
              check-strictly :render-after-expand="false" style="min-width: 210px;" />
          </el-col>
        </el-form-item>
        <el-form-item v-if="showOrgFilters" label="仓库" prop="storeCode">
          <el-select v-model="storeCode" placeholder="仓库" size="default" @change="fetchs()" clearable
            style="min-width: 90px;">
            <el-option v-for="item in stores" :key="item.value" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="库存日期">
          <el-col>
            <!-- <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
            </el-date-picker> -->
            <el-date-picker v-model="dateDay" type="date" placeholder="查询日期" @change="fetchs()"
              style="max-width:180px;" />
          </el-col>
        </el-form-item>

        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="search" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="primary" icon="Download" @click="download()">导出</el-button>

      <span style="margin-left: 30px;" v-if="daysData">
        库存统计(所属公司)：<el-tag type="primary" size="large">{{ $util.fmtDate(daysData.dayDate, "yyyy-MM-dd") }}</el-tag>，
        库存总数：<el-tag type="success" size="large">{{ daysData.dayRemain }}</el-tag>，
        库存总额：<el-tag type="success" size="large">{{ $util.fmtMoney(daysData.sumProductPrice) || '0.00'
        }}（{{ daysData.sumProductPrice }}）</el-tag>
      </span>
    </div>

    <basic-table ref="table" class="table" :query="query" @handler="fetchs">
      <template v-slot:detailImg="scope">
        <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
          :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
          <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
        </el-image>
      </template>
      <template v-slot:dayDate="scope">
        <div>{{ $util.fmtDate(scope.row.dayDate, "yyyy-MM-dd") }}</div>
      </template>
    </basic-table>
  </el-card>
</template>

<script>
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
import { pa } from "element-plus/es/locales.mjs";
export default {
  name: "StockBoundDays",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      apiUrl: "",
      dateDay: null,
      dateRange: [],
      query: {
        keyword: "",
        columns: [
          { type: "index", label: "序号" },
          { prop: "storeCode", label: "库房", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "channel", label: "渠道", sortable: true, searchable: true, width: "85", showOverflowTooltip: true },
          { prop: "detailCode", label: "款号", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },
          { type: "template", prop: "detailImg", label: "图片", width: "50", },
          { prop: "detailName", label: "产品名称", sortable: true, searchable: true, width: "160", showOverflowTooltip: true },
          { type: "template", prop: "dayDate", label: "库存日期", sortable: true, searchable: true, width: "100", showOverflowTooltip: true },

          { prop: "dayRemain", label: "当日库存", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },
          { prop: "sumGoldWeight", label: "合计金重", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },
          { prop: "avgUnitPrice", label: "平均单价", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },
          { prop: "avgPurchasePrice", label: "平均采购价", sortable: true, width: "110", showOverflowTooltip: true, align: "right" },
          { prop: "avglabelPrice", label: "平均标签价", sortable: true, width: "110", showOverflowTooltip: true, align: "right" },
          { prop: "avgProductPrice", label: "平均入库价", sortable: true, width: "110", showOverflowTooltip: true, align: "right" },

          { prop: "sumPurchasePrice", label: "采购总价", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },
          { prop: "sumLabelPrice", label: "标签总价", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },
          { prop: "sumProductPrice", label: "入库总价", sortable: true, width: "90", showOverflowTooltip: true, align: "right" },

          { prop: "serialCodes", label: "批次号集合", sortable: true, searchable: true, width: "130", showOverflowTooltip: true },

          { prop: "createDate", label: "更新时间", sortable: true, width: "150", showOverflowTooltip: true },
        ],
        filters: [],
        sidx: "id",
        sord: "desc"
      },
      daysData: {},
      companys: [],
      companyId: null,
      channels: [],
      channel: null,
      stores: [],
      storeCode: null,
    };
  },
  mounted() {
    if (this.showOrgFilters) {
      this.$kaung.companys().then((res) => {
        this.companys = res;
      });
    } else {
      this.companyId = '*';
    }

    this.$kaung.dictionary("stock", "store").then(res => this.stores = res);

    this.apiUrl = process.env.VUE_APP_BASEURL;
    //kaung插件初始化
    this.$kaung.init(this.$options.name);
    this.fetchs();
  },
  methods: {
    companyChange() {
      this.channel = null;
      this.getChannels();
      this.fetchs();
    },
    getChannels() {
      if (!this.companyId || this.companyId === '*') {
        this.channels = [];
        return;
      }
      this.$kaung.departments(this.companyId).then((res) => {
        //this.channels = res || [];
        //后端需要名称，这里将value改为label
        this.channels = (res || []).map(item => { return { value: item.label, label: item.label } });
      });
    },
    fetchs() {
      this.query.filters = [];

      if (this.showOrgFilters) {
        if (!this.companyId || this.companyId.length == 0) {
          this.companyId = this.$store.getters.getUserInfo?.companyID || '';
          this.getChannels();
        }
        if (this.companyId) {
          this.query.filters.push({ name: "companyId", value: this.companyId, operate: 0, });
        }
      }
      if (this.channel) {
        this.query.filters.push({ name: "channel", value: this.channel, operate: 0, });
      }
      if (this.storeCode) {
        this.query.filters.push({ name: "storeCode", value: this.storeCode, operate: 0, });
      }

      if (this.dateDay) {
        this.query.filters.push({ name: "dayDate", value: this.$util.fmtDate(this.dateDay, "yyyy-MM-dd"), operate: 0 });
      }

      // if (this.dateRange && this.dateRange[0]) {
      //   this.query.filters.push({ name: "dayDate", value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"), operate: 2 });
      // }
      // if (this.dateRange && this.dateRange[1]) {
      //   this.query.filters.push({ name: "dayDate", value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59", operate: 4 });
      // }

      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.search(params).then((res) => {
        this.query = { ...res.data };
      });

      this.getDaysData();
    },
    download() {
      let { data, records, total, ...params } = { ...this.query };
      this.$kaung.export(params).then((res) => {
        this.$notify({
          title: '表格数据导出',
          message: res.content,
          type: res.type,
          duration: 10000
        });
        window.location.href = process.env.VUE_APP_BASEURL + res.data;
      });
    },

    getDaysData() {
      this.$kaung.fetch({
        url: '/StockBoundDays/GetDaysData',
        params: {
          date: this.$util.fmtDate(this.dateDay, "yyyy-MM-dd"),
          companyId: (this.companyId || ''),
          channel: (this.channel || ''),
          storeCode: (this.storeCode || '')
        },
        method: 'get'
      }).then((res) => {
        this.daysData = res.data;
      });
    }
  },
};
</script>
